<div class="comment single-comment-gallery">
  <div class="comment__info info info_custom">
    <div class="coment-autor">
      <div class="info__avater">
        <ng-container *ngIf="comment.user?.photoUrl; else noAva">
          <img class="border-radius-50" src="{{comment.user.photoUrl}}">
        </ng-container>
        <ng-template #noAva>
          <fa-icon class="default-avatar" [icon]="['fas', 'user-circle']"></fa-icon>
        </ng-template>
      </div>
      <div class="info__username">{{comment.user?.fullName || comment.user?.login}}</div>
    </div>

    <div *ngIf="comment.taskId" (click)="openTask()" class="task-mark"> Задача для МЧ </div>
  </div>

  <div class="comment__text comment__text_custom">
    <span> {{comment.comment}}</span>
  </div>
  <div class="info__date info__date_custom">{{comment.commentCreatedDate | date: 'dd.MM.yyyy г. в HH:mm'}}</div>

  <div *ngIf="isTaskOpen" class="task-result">
    <div class="task-result-title">Информация о задаче</div>
    <!-- <div class="task-result-info">

       <div> 
         <span class="bold"> Для: </span> <span> Мерчандайзера</span>
         <br>
       <span class="bold">От: </span>  <span> Мерчандайзера</span>
       </div>
    </div> -->

    <div class="task-result-text">
      Скоро здесь будут отображаться результаты выполнения задачи
    </div>

    <div class="task-result-photo">
      <div class="no-photo">
        <img src="/assets/images/no_photo.jpg" alt="">
      </div>
    </div>


    <div class="ok-container">
      <button (click)="closeTask()" class="tr-buttton ok-button"> Ок</button>
    </div>

  </div>
</div>
